import { useNavigate } from "react-router";
import { Button } from "../externalComponents/tailwind/button";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      className="h-full"
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <p>This page doesn't exist</p>
      <br />
      <Button color="primaryButton" onClick={() => navigate("/dashboard")}>
        Back to home page
      </Button>
    </div>
  );
}
